import * as React from 'react';
import LanguageMenuContent from '../../../MenuContent/LanguageMenuContent';
import PopoverMenu from '../../../PopoverMenu/PopoverMenu';
import useAppContext from '../../../../hooks/context/useAppContext';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { isLanguageSupported, supportedLanguages } from '../../../../localizations/index';
import { makeStyles } from '@material-ui/core/styles';
import { useChangeUserLanguage } from '../../../../pages/UserDetailPage/hooks/api/userApi';
import { useCallback } from 'react';
import styled from 'styled-components';
import { useIntl } from 'react-intl';

const useStyle = makeStyles(() => ({
  title: {
    display: 'flex',
    flexDirection: 'row',
    gap: '7px',
    fontSize: '15px',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const LanguageTitle = styled.div`
  font-weight: 600;
  color: #000000;
  @media all and (width <= 500px) {
    display: none;
  }
`;

const LanguageMenu = () => {
  const { user, setUser } = useAppContext();
  const language = supportedLanguages.find((supportedLanguage) => supportedLanguage.languageCode === user.language);
  const classes = useStyle();
  const { changeUserLanguage } = useChangeUserLanguage();
  const intl = useIntl();

  const changeLanguage = useCallback(
    (supportedLanguage) => {
      if (isLanguageSupported(supportedLanguage.languageCode)) {
        changeUserLanguage(user.id, supportedLanguage.code).then(() => {
          const updatedUser = { ...user, language: supportedLanguage.languageCode };
          setUser(updatedUser);
        });
      }
    },
    [changeUserLanguage, user, setUser],
  );

  return (
    <PopoverMenu
      ariaLabel={intl.formatMessage({ id: 'app.menu.aria.language' })}
      icon={
        <div className={classes.title}>
          <LanguageTitle>{language?.title || 'EN'}</LanguageTitle> <ExpandMoreIcon style={{ color: '#00C752' }} />
        </div>
      }>
      <LanguageMenuContent changeLanguage={changeLanguage} />
    </PopoverMenu>
  );
};

LanguageMenu.propTypes = {};

export default LanguageMenu;
